import { useState } from "react";
import { Ellipsis, Pencil } from "lucide-react";

import ACL_RELATIONSHIPS from "acl-relationships";
import { buttonVariants } from "@/components/ui/button";
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from "@/components/ui/dropdown-menu";
import Authorized from "components/Authorized";
import GroupModal from "routes/admin/components/GroupModal";

const EDIT_ACLS = [ACL_RELATIONSHIPS.adminGroup.edit];

export function GroupsTableActions({ original }) {
  const [editOpen, setEditOpen] = useState(false);

  return (
    <Authorized permissions={EDIT_ACLS}>
      <DropdownMenu>
        <DropdownMenuTrigger
          aria-label="Group actions"
          className={buttonVariants({ variant: "ghost", size: "icon-sm" })}
        >
          <Ellipsis />
        </DropdownMenuTrigger>
        <DropdownMenuContent align="end" className="tw:w-auto">
          <DropdownMenuItem onClick={() => setEditOpen(true)}>
            <Pencil />
            Edit
          </DropdownMenuItem>
        </DropdownMenuContent>
      </DropdownMenu>
      <GroupModal model={original} open={editOpen} onOpenChange={setEditOpen} />
    </Authorized>
  );
}
